import { isValid, isBefore, parse } from "date-fns";
import { isNil } from "lodash";
import { isPossiblePhoneNumber, isValidPhoneNumber } from "react-phone-number-input";
export const isValidInn = (i) => {
    if (isNil(i)) {
        return true;
    }
    if (typeof i === "string" || typeof i === "number") {
        const inn = i.toString();
        if (inn.length === 0) {
            return true;
        }
        if ((/^\d+$/).test(inn) === false) {
            return false;
        }
        if (+inn === 0) {
            return false;
        }
        if (inn.length === 10) {
            return +inn.charAt(9) === ((2 * +inn.charAt(0) +
                4 * +inn.charAt(1) +
                10 * +inn.charAt(2) +
                3 * +inn.charAt(3) +
                5 * +inn.charAt(4) +
                9 * +inn.charAt(5) +
                4 * +inn.charAt(6) +
                6 * +inn.charAt(7) +
                8 * +inn.charAt(8)) % 11) % 10;
        }
        if (inn.length === 12) {
            return (+inn.charAt(10) === ((7 * +inn.charAt(0) +
                2 * +inn.charAt(1) +
                4 * +inn.charAt(2) +
                10 * +inn.charAt(3) +
                3 * +inn.charAt(4) +
                5 * +inn.charAt(5) +
                9 * +inn.charAt(6) +
                4 * +inn.charAt(7) +
                6 * +inn.charAt(8) +
                8 * +inn.charAt(9)) % 11) % 10) &&
                (+inn.charAt(11) === ((3 * +inn.charAt(0) +
                    7 * +inn.charAt(1) +
                    2 * +inn.charAt(2) +
                    4 * +inn.charAt(3) +
                    10 * +inn.charAt(4) +
                    3 * +inn.charAt(5) +
                    5 * +inn.charAt(6) +
                    9 * +inn.charAt(7) +
                    4 * +inn.charAt(8) +
                    6 * +inn.charAt(9) +
                    8 * +inn.charAt(10)) % 11) % 10);
        }
        return false;
    }
    return false;
};
export const isValidOgrn = (o) => {
    if (isNil(o)) {
        return true;
    }
    const ogrn = o.toString();
    return (ogrn.length === 0
        || (ogrn.length === 13 && (ogrn.slice(12, 13) === (+ogrn.slice(0, -1) % 11).toString().slice(-1)))
        || (ogrn.length === 15 && (ogrn.slice(14, 15) === (+ogrn.slice(0, -1) % 13).toString().slice(-1))));
};
export const isValidEmail = (e) => {
    // eslint-disable-next-line
    return isNil(e) || e.length === 0 || (e.length > 0 && /^(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(e));
};
export const isValidUrl = (u) => {
    // eslint-disable-next-line
    return isNil(u) || u.length === 0 || (/(http(s)?:\/\/.)?(www\.)?[-a-zа-яё0-9@:%._\+~#=]{2,256}\.[a-zа-яё]{2,10}([-a-z0-9@:%_\+.~#?&//=]*)/gi).test(u);
};
export const isValidPhone = (p, possible) => {
    if (isNil(p) || p.length === 0) {
        return true;
    }
    let phone = p;
    if (!p.startsWith("+")) {
        phone = `+${phone}`;
    }
    return possible ? isPossiblePhoneNumber(phone) : isValidPhoneNumber(phone);
};
export const isValidDate = (d, options) => {
    if (isNil(d) || (typeof d === "string" && d.length === 0)) {
        return true;
    }
    const parsedDate = d.split(".");
    if (parsedDate[2] === undefined || +parsedDate[2] < 1900) {
        return false;
    }
    try {
        const convertedDate = parse(d, "dd.MM.yyyy", new Date());
        if (isValid(convertedDate)) {
            if (options?.max) {
                return isBefore(convertedDate, options.max);
            }
            return true;
        }
        return false;
    }
    catch (e) {
        return false;
    }
};
